(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lo-ten-reasons"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lo-ten-reasons')) {
  customElements.define('lo-ten-reasons', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const animations = [...this.querySelectorAll('[data-lor-motion]')].map(image => {
        image.dataset.posterSrc ||= image.getAttribute('src');
        return image;
      });
      const updateMotion = () => animations.forEach(image => {
        image.setAttribute('src', preference.matches ? image.dataset.posterSrc : image.dataset.motionSrc);
      });
      updateMotion();
      preference.addEventListener('change', updateMotion, {signal});

      const sticky = this.querySelector('[data-lor-sticky]');
      const intro = this.querySelector('.lor-article-intro');
      if (sticky && intro) {
        this.stickySpacer = document.createElement('div');
        this.stickySpacer.setAttribute('aria-hidden', 'true');
        this.stickySpacer.dataset.lorStickySpacer = '';
        const appendSpacer = () => document.body.append(this.stickySpacer);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', appendSpacer, {once: true, signal});
        } else {
          appendSpacer();
        }
        const updateSpace = () => {
          if (!this.stickySpacer) return;
          this.stickySpacer.style.height = sticky.hidden ? '0px' : `${Math.ceil(sticky.getBoundingClientRect().height)}px`;
        };
        const updateVisibility = () => {
          sticky.hidden = intro.getBoundingClientRect().bottom > 0;
          updateSpace();
        };
        updateVisibility();
        if ('IntersectionObserver' in window) {
          this.stickyObserver = new IntersectionObserver(updateVisibility, {threshold: 0});
          this.stickyObserver.observe(intro);
        } else {
          window.addEventListener('scroll', updateVisibility, {passive: true, signal});
        }
        window.addEventListener('resize', updateVisibility, {signal});
        if ('ResizeObserver' in window) {
          this.stickyResizeObserver = new ResizeObserver(updateSpace);
          this.stickyResizeObserver.observe(sticky);
        }
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.stickyObserver?.disconnect();
      this.stickyResizeObserver?.disconnect();
      this.stickySpacer?.remove();
      this.stickySpacer = null;
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
